import WOTemplateForm from './WOTemplateForm';

export default WOTemplateForm;
export * from './WOTemplateForm';
